// src/components/dashboard/superadmin/UsersByRoleList.js
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

const ROLE_LABELS = {
  admin: 'Super Admin',
  masteradmin: 'Master Admin',
  companyadmin: 'Company Admin',
  departmentadmin: 'Department Admin',
  trainingadmin: 'Training Vendor',
  trainer: 'Trainer',
  employee: 'Employee',
};

function UsersByRoleList({ data, loading }) {
  const total = data.reduce((sum, row) => sum + row.count, 0);

  return (
    <DashboardCard
      title={`Total Users (${total})`}
      icon="bi-people-fill"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No users found."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {data.map(row => (
            <tr key={row.role}>
              <td>{ROLE_LABELS[row.role] || row.role}</td>
              <td className="text-end text-muted">{row.count}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default UsersByRoleList;
